import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

// --- Icons ---
const DashboardIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>;
const OperationsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>;
const NurseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle></svg>;
const HRIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const TransportationIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 16.5V8.28a1 1 0 0 0-1.63-.77L9 12l-4-4-2 2.5"></path><path d="M14 16.5h3.53a1 1 0 0 0 .84-.44l2.23-3.12a1 1 0 0 0 0-1.12L18.37 8.7a1 1 0 0 0-.84-.44H14"></path><circle cx="17.5" cy="16.5" r="2.5"></circle><circle cx="6.5" cy="16.5" r="2.5"></circle></svg>;
const AnalyticsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"></path><path d="m19 9-5 5-4-4-3 3"></path></svg>;
const SettingsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 0 2l-.15.08a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l-.22-.38a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1 0 2l.15-.08a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const ChevronLeftIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>;
const ChevronDownIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>;
const ChevronRightIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>;
const LordsERPIcon = (props: { style?: React.CSSProperties }) => <svg style={props.style} width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" fill="#3B82F6"/><path d="M12 12L22 7L12 2L2 7L12 12Z" fill="#60A5FA"/><path d="M12 12V22L22 17V7L12 12Z" fill="#1D4ED8"/></svg>;
const CertificateIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M12 18l3 3 3-3"></path><path d="M15 21V11"></path></svg>;
const BillingIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>;
const MedEquipIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>;

const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

interface SidebarProps {
  isMinimized: boolean;
  toggleSidebar: () => void;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isMinimized, toggleSidebar, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState<string | null>(null);
  
  const [openMenus, setOpenMenus] = useState<{[key: string]: boolean}>({
    'client-dashboard': true,
    'hr-module': true,
  });

  const toggleMenu = (key: string) => {
    setOpenMenus(prev => ({ ...prev, [key]: !prev[key] }));
  };

  // --- NEW: Helper to auto-minimize on navigation ---
  const handleLinkClick = () => {
    // Only toggle if it's currently OPEN (not minimized)
    if (!isMinimized) {
      toggleSidebar();
    }
  };

  const menuItems = [
    {
      key: 'client-dashboard',
      icon: <DashboardIcon />,
      name: 'Client Dashboard',
      children: [
        { path: '/patients',    icon: <DashboardIcon />,   name: 'Client List' },
        { path: '/assignments', icon: <OperationsIcon />,  name: 'Operations' },
        { path: '/operations',  icon: <OperationsIcon />,  name: 'Local Operations' },
        { path: '/casesheet',                              name: 'Case Sheet' },
      ]
    },
    { 
      key: 'hr-module', 
      icon: <HRIcon />, 
      name: 'HR Module', 
      children: [
        { path: '/nurses', icon: <NurseIcon />, name: 'Nurse List' },
        { path: '/salarysheet?tab=nurse', name: 'Salary Sheet (Nurse)' },
        { path: '/administration/management-staff', name: 'Management Staff' },
        { path: '/salarysheet?tab=management', name: 'Salary Sheet (Mgmt)' },
        { path: '/administration/physio',           name: 'Physio' },
        { path: '/salarysheet?tab=physio', name: 'Salary Sheet (Physio)' },
        { path: '/idcards', name: 'ID Card Generator' },
        { path: '/experience-certificates', icon: <CertificateIcon />, name: 'Exp Certificate' },
      ]
    },
    {
      key: 'medical-equipment',
      icon: <MedEquipIcon />,
      name: 'Medical Equipment',
      children: [
        { path: '/administration/medical-devices',  name: 'Medical Devices' },
        { path: '/administration/consumables',      name: 'Consumables' },
      ]
    },
    {
      key: 'billing-module',
      icon: <BillingIcon />,
      name: 'Billing',
      children: [
        { path: '/billing', name: 'Client List' },
        { path: '/billing/current-clients', name: 'Current Client List' },
        { path: '/billing/collections', name: 'Payment Collections' },
        { path: '/billing/current-collections', name: 'Current Payment Collections' },
        { path: '/billing/deleted', icon: <TrashIcon />, name: 'Deleted Bills' },
      ]
    },
    {
      key: 'financial-module',
      icon: <AnalyticsIcon />,
      name: 'Financial',
      children: [
        { path: '/financial/dashboard', name: 'Dashboard' },
        { path: '/financial/spend-analyser', name: 'Spend Analyser' },
        { path: '/financial', name: 'P&L Entry' },
        { path: '/financial/ledger', name: 'Full Ledger' },
        { path: '/financial/petty-cash', name: 'Petty Cash' },
      ]
    },
    { path: '/settings', icon: <SettingsIcon />, name: 'Settings' },
  ];

  // --- Styles ---
  const styles: { [key: string]: React.CSSProperties } = {
    // 1. BACKDROP: Dims the screen behind the sidebar
    backdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      zIndex: 999, // High Z-Index to sit above content
      display: isMinimized ? 'none' : 'block',
      backdropFilter: 'blur(2px)'
    },
    
    // 2. SIDEBAR: Fixed positioning + High Z-Index = Overlay
    sidebar: {
      height: '100vh',
      backgroundColor: '#1e293b',
      color: '#cbd5e1',
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed', // This ensures it overlays
      top: 0,
      left: 0,
      width: isMinimized ? '80px' : '250px',
      transition: 'width 0.3s ease-in-out',
      overflowY: 'auto',
      zIndex: 1000, // Higher than backdrop and main content
      boxShadow: isMinimized ? 'none' : '4px 0 15px rgba(0,0,0,0.3)',
      borderRight: '1px solid #334155'
    },
    logoContainer: {
        padding: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        flexShrink: 0,
        cursor: isMinimized ? 'pointer' : 'default',
        borderBottom: '1px solid #334155',
        marginBottom: '1rem'
    },
    logoIcon: { position: 'relative', zIndex: 1 },
    logoText: { fontSize: '1.25rem', fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' },
    menu: { flexGrow: 1, listStyle: 'none', padding: '0 1rem', margin: 0 },
    
    menuItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '0.75rem',
        borderRadius: '0.375rem',
        marginBottom: '0.25rem',
        cursor: 'pointer',
        transition: 'all 0.2s',
        textDecoration: 'none',
        color: '#94a3b8',
        position: 'relative'
    },
    menuItemActive: { backgroundColor: '#2563eb', color: 'white' },
    menuItemHover: { backgroundColor: '#334155', color: 'white' },
    
    menuItemText: { marginLeft: '0.75rem', whiteSpace: 'nowrap', flex: 1, fontSize: '0.9rem', fontWeight: 500 },
    
    submenu: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        paddingLeft: isMinimized ? '0' : '1rem',
        overflow: 'hidden',
        transition: 'max-height 0.3s ease-in-out',
    },
    submenuItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '0.6rem 0.75rem 0.6rem 2.75rem',
        borderRadius: '0.375rem',
        marginBottom: '0.1rem',
        textDecoration: 'none',
        color: '#94a3b8',
        fontSize: '0.85rem',
        transition: 'color 0.2s'
    },
    submenuItemActive: { color: '#60a5fa', fontWeight: 600, backgroundColor: 'rgba(37, 99, 235, 0.1)' },
    
    closeButton: { marginLeft: 'auto', backgroundColor: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.25rem', borderRadius: '9999px' },
    chevron: { marginLeft: 'auto', color: '#64748b' }
  };

  return (
    <>
      {/* Backdrop for clicking outside */}
      {!isMinimized && (
        <div style={styles.backdrop} onClick={toggleSidebar} />
      )}

      <nav style={styles.sidebar}>
        <div style={styles.logoContainer} onClick={isMinimized ? toggleSidebar : undefined}>
          <LordsERPIcon style={styles.logoIcon} />
          {!isMinimized && <span style={styles.logoText}>LORDS ERP</span>}
          {!isMinimized && (
            <button onClick={toggleSidebar} style={styles.closeButton}>
              <ChevronLeftIcon />
            </button>
          )}
        </div>

        <ul style={styles.menu}>
          {menuItems.map((item, index) => {
            const isItemHovered = hoveredIndex === (item.key || item.path);
            
            // 1. RENDER SUBMENU PARENT
            if (item.children) {
                const isOpen = openMenus[item.key || ''];
                const isActiveChild = item.children.some(child => location.pathname.startsWith(child.path));
                
                return (
                  <li key={item.key} onMouseEnter={() => setHoveredIndex(item.key || '')} onMouseLeave={() => setHoveredIndex(null)}>
                      <div 
                          style={{
                              ...styles.menuItem, 
                              ...(isActiveChild ? { color: 'white' } : {}), 
                              ...(isItemHovered ? styles.menuItemHover : {})
                          }}
                          // Clicking parent only toggles menu, DOES NOT minimize sidebar
                          onClick={() => {
                  if (isMinimized) {
                      toggleSidebar(); // 1. Expand Sidebar
                      if (item.children && item.children[0]) {
                          navigate(item.children[0].path); // 2. Go to first sub-page
                          // 3. Force open the submenu if it's closed
                          if (!openMenus[item.key || '']) toggleMenu(item.key || ''); 
                      }
                  } else {
                      toggleMenu(item.key || ''); // Standard behavior
                  }
              }}
          >
                          {item.icon}
                          {!isMinimized && (
                              <>
                                  <span style={styles.menuItemText}>{item.name}</span>
                                  <span style={styles.chevron}>
                                      {isOpen ? <ChevronDownIcon /> : <ChevronRightIcon />}
                                  </span>
                              </>
                          )}
                      </div>

                      {!isMinimized && isOpen && (
                          <ul style={styles.submenu}>
                              {item.children.map((child) => {
                                  // Use exact matching for an "index-like" child whose path is a
                                  // prefix of a sibling's (e.g. /financial vs /financial/dashboard),
                                  // so it doesn't stay highlighted on the sibling's nested route.
                                  const exact = item.children.some(o => o.path !== child.path && o.path.startsWith(child.path + '/'));
                                  return (
                                  <li key={child.path}>
                                      <NavLink
                                          to={child.path}
                                          end={exact}
                                          // CLICKING CHILD LINK TRIGGERS MINIMIZE
                                          onClick={handleLinkClick}
                                          style={({ isActive }) => ({
                                              ...styles.submenuItem,
                                              ...(isActive ? styles.submenuItemActive : {}),
                                              ...(hoveredIndex === child.path ? { color: 'white' } : {})
                                          })}
                                          onMouseEnter={(e) => { e.stopPropagation(); setHoveredIndex(child.path); }}
                                          onMouseLeave={(e) => { e.stopPropagation(); setHoveredIndex(null); }}
                                      >
                                          {child.name}
                                      </NavLink>
                                  </li>
                                  );
                              })}
                          </ul>
                      )}
                  </li>
                );
            }

            // 2. RENDER STANDARD LINK
            return (
              <li key={item.path} onMouseEnter={() => setHoveredIndex(item.path || '')} onMouseLeave={() => setHoveredIndex(null)}>
                <NavLink
                  to={item.path || ''}
                  // CLICKING STANDARD LINK TRIGGERS MINIMIZE
                  onClick={handleLinkClick}
                  title={item.name}
                  style={({ isActive }) => ({
                    ...styles.menuItem,
                    ...(isActive ? styles.menuItemActive : {}),
                    ...(!isActive && isItemHovered ? styles.menuItemHover : {}),
                  })}
                >
                  {item.icon}
                  {!isMinimized && <span style={styles.menuItemText}>{item.name}</span>}
                </NavLink>
              </li>
            );
          })}
        </ul>

        {/* Logout — pinned to bottom */}
        <div style={{ padding: '1rem', borderTop: '1px solid #334155', flexShrink: 0 }}>
          <button
            onClick={onLogout}
            title="Log Out"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              width: '100%',
              padding: '0.65rem 0.75rem',
              borderRadius: '0.375rem',
              border: 'none',
              backgroundColor: 'transparent',
              color: '#94a3b8',
              cursor: 'pointer',
              transition: 'all 0.2s',
              fontSize: '0.9rem',
              fontWeight: 500,
            }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLElement).style.backgroundColor = 'rgba(239,68,68,0.12)';
              (e.currentTarget as HTMLElement).style.color = '#f87171';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLElement).style.backgroundColor = 'transparent';
              (e.currentTarget as HTMLElement).style.color = '#94a3b8';
            }}
          >
            <LogoutIcon />
            {!isMinimized && <span style={{ whiteSpace: 'nowrap' }}>Log Out</span>}
          </button>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;